import utils from 'utils'
import Invoice from '../invoice1/model/Invoice'
import Customer from '../invoice1/model/Customer'
import Goods from '../invoice1/model/Goods'
import Sale from '../invoice1/model/Sale'
import Ukey from '../invoice1/model/Ukey'
import {
    submitCheck,
} from '../invoice1/invoiceValidate'
import modalInvoiceTitle from '../invoice1/view/modalInvoiceTitle.html'

export default class rollTypeInvoiceAddCtrl {
    constructor($scope, httpRequest, $state, $stateParams, logger, dictService, $filter, $timeout, billChangeService, invoiceOpenService, operationService, sweetalert, buyerChecker, $uibModal) {
        // 如果是控制台则增加样式
        $state.current.name.split('.').forEach(i => {
            if (i == 'workspace') $scope.haveBorder = true
            if (i == 'redInfoRoll') $scope.isRedInfo = true
            if (i == 'cancelInvoice') $scope.isCancelReopenInv = true
        })
        if ($state.current.name.indexOf('rollTypeInvoice.add') > -1) {
            $scope.isAddRoll = true
            updateScanlen()
        }
        if ($stateParams.canceledInvoiceId) {
            $scope.canceledInvoiceId = $stateParams.canceledInvoiceId
        }

        $scope.totalInvoice = 1 // 发票总张数
        $scope.currentInvoice = 1 // 当前张数
        $scope.waitId = $state.params.waitId
        $scope.parentInvoiceId = $state.params.parentInvoiceId // 红冲父票id
        let paramArr = []
        if ($state.params.waitId) {
            paramArr = $state.params.waitId.split('options')
            $scope.waitId = paramArr[0]
            if (paramArr.length > 1) {
                const invoiceArr = JSON.parse(paramArr[1])
                $scope.totalInvoice = invoiceArr.length
                $scope.currentInvoice = invoiceArr.indexOf($scope.waitId) + 1
            }
        }
        $scope.showOperateBtn = function (flag) {
            $scope.showOperate = flag
            if ($scope.currentInvoice > 1 && $scope.currentInvoice < $scope.totalInvoice) {
                $scope.showOperateLeft = true
                $scope.showOperateRight = true
            } else if ($scope.currentInvoice > 1) {
                $scope.showOperateLeft = true
                $scope.showOperateRight = false
            } else if ($scope.currentInvoice < $scope.totalInvoice) {
                $scope.showOperateLeft = false
                $scope.showOperateRight = true
            }
        }
        // 翻页按钮
        $scope.changepage = function (val) {
            const list = JSON.parse(paramArr[1])
            if (val > 0) {
                $state.go('workspace.item.roll', {
                    waitId: `${list[$scope.currentInvoice]}options${JSON.stringify(list)}`,
                })
            } else {
                $state.go('workspace.item.roll', {
                    waitId: `${list[$scope.currentInvoice - 2]}options${JSON.stringify(list)}`,
                })
            }
        }
        /**
         * 获取商品税率数组
         * @param  {object} goods       商品对象
         * @param  {string} invoiceType 发票种类
         */
        function getGoodsInfoTax(goods, invoiceType) {
            const rateReq = {
                taxMergeCode: goods.taxMergeCode || goods.revenueCode,
                invType: invoiceType,
                privilegeType: encodeURIComponent(goods.privilegeType),
            }
            return httpRequest.get_queryGoodsTax(rateReq).then((res) => {
                const taxRateArr = res.data.value
                goods.taxRateArr = taxRateArr
                if (goods.taxRate || goods.taxRate === 0) {
                    for (let i = 0, {
                            length
                        } = taxRateArr; i < length; i++) {
                        const taxRateItem = taxRateArr[i]
                        if (taxRateItem.taxRate === goods.taxRate &&
                            taxRateItem.privilegeType === goods.privilegeType) {
                            goods.taxRateObj = taxRateItem
                            break
                        }
                    }
                }
                const zeroTaxArr = $scope.dictionary.zero_tax
                for (let i = 0, l = zeroTaxArr.length; i < l; i++) {
                    if (zeroTaxArr[i].enumName === goods.privilegeType && taxRateArr[0].taxRate === 0) {
                        goods.zeroTax = zeroTaxArr[i].enumCode
                    }
                }
                return taxRateArr
            })
        }
        $scope.invoice = new Invoice()
        dictService.getAndCache(['zero_tax']).then((res) => {
            $scope.dictionary = res
            $scope.init()
        })
        /**
         * 根据开票点和发票种类获取库存数量和最新发票代码号码
         */
        function getStockByUkey() {
            invoiceOpenService.getStockByUkey(
                $scope.invoice.ukey.ukeyList,
                $scope.invoice.ukey.ukeyId,
                '41',
            ).then((obj) => {
                if (obj) {
                    $scope.hintMsg = `剩余发票数量: ${obj.sum}`
                    $scope.invoice.invoiceCode = obj.invoiceCode
                    $scope.invoice.invoiceNumber = obj.invoiceNumber
                }
            }, (error) => {
                $scope.hintMsg = error
                $scope.invoice.invoiceCode = ''
                $scope.invoice.invoiceNumber = ''
            })
        }
        /**
         * 根据发票开票点ID获取开票点对象
         */
        function getSelectedUkey() {
            let selectedUkey
            $scope.invoice.ukey.ukeyList.forEach((ukey) => {
                if ($scope.invoice.ukey.ukeyId === ukey.ukeyId) {
                    selectedUkey = ukey
                    // $scope.invoice.ukey = new Ukey().fromUkey(ukey)
                }
            })
            return selectedUkey
        }
        /**
         * 获取发票限额
         */
        function getQuotasByUkey() {
            httpRequest.get_getTaxDisk($scope.invoice.ukey.ukeyId).then((res) => {
                const data = res.data.value
                $scope.invoice.ukey.quotas['41'] = data.volumeQuota
                // 金税盘机器号
                $scope.invoice.diskNo = data.diskNo
            })
        }
        // 是否为详情
        if ($state.current.name === 'outputManage.FOManage.rollTypeInvoice.detail' || $state.current.name === 'workspace.item.roll') $scope.isDetail = true
        if ($state.current.name == 'outputManage.FOManage.rollTypeInvoice.addred') {
            $scope.isRed = true
        }

        // 隐藏一二级菜单
        if ($scope.isDetail) {
            $('#wrapper').addClass('invoiceDetailPage')
            $scope.$on('$stateChangeStart', () => {
                $('#wrapper').removeClass('invoiceDetailPage')
            })
        }
        $scope.init = async function init() {
            if ($scope.waitId) {
                const invoiceRes = await httpRequest.get_queryOvatInvoiceWait({
                    waitId: $scope.waitId,
                })
                $scope.invoice = new Invoice(invoiceRes.data.value)
                if ($scope.isRedInfo) { // 已开红冲清空billcode
                    $scope.invoice.billCode = ''
                }
                $scope.invoice.details.forEach((detail) => {
                    // detail.goodsObject = { shortAndMatName: detail.shortAndMatName }
                    // detail.adValoremTotal = (+detail.adValoremTotal).toFixed(2)
                    getGoodsInfoTax(detail, '41')
                })
                $scope.rollticketCode = JSON.parse($scope.invoice.extendInfo).rollticketCode
                getStockByUkey()
                getQuotasByUkey()
            } else if ($scope.isRedInfo) {
                const waitIdRes = await httpRequest.get_getBeanId_dkfp()
                httpRequest.post_getOvatInvoice($scope.parentInvoiceId).then((res1) => {
                    $timeout(() => {
                        const blueInvocie = res1.data.value
                        $scope.blueInvocie = blueInvocie
                        $scope.invoice.fromBlue(blueInvocie)
                        $scope.invoice.invType = blueInvocie.invType
                        $scope.invoice.waitId = waitIdRes.data.value.split(',')[0]
                        $scope.rollticketCode = blueInvocie.extendInfo && JSON.parse(blueInvocie.extendInfo).rollticketCode
                        getStockByUkey()
                        getQuotasByUkey()
                    })
                })
            } else if ($scope.isCancelReopenInv) {
                const waitIdRes = await httpRequest.get_getBeanId_dkfp()
                httpRequest.post_getOvatInvoice($scope.canceledInvoiceId).then((res1) => {
                    const blue = res1.data.value
                    if (blue.isRed == '1') {
                        $scope.isRed = '1'
                        $scope.invoice.$isRed = '1'
                        $scope.invoice.redToRed(blue)
                        $scope.invoice.invType = blue.invType
                        $scope.invoice.waitId = waitIdRes.data.value.split(',')[0]
                    } else {
                        $scope.invoice = new Invoice()
                        $scope.invoice.waitId = waitIdRes.data.value.split(',')[0]
                        $scope.invoice.invType = $stateParams.invType
                        $scope.invoice.invoiceDate = `${$filter('date')(new Date(), 'yyyy-MM-dd')} 00:00:00`
                        $scope.copyInvoice(blue)
                    }
                    $scope.invoice.billCode = blue.billCode
                    $scope.invoice.invoiceSource = blue.invoiceSource
                    $scope.invoice.ukey.ukeyId = blue.ukeyId
                    $scope.invoice.ukeyId = blue.ukeyId
                    $scope.changerUkeyId()
                })
            } else {
                $scope.invoice = new Invoice()
                const waitIdRes = await httpRequest.get_getBeanId_dkfp()
                $scope.invoice.waitId = waitIdRes.data.value.split(',')[0]
                $scope.invoice.invType = $stateParams.invType
                $scope.invoice.invoiceDate = `${$filter('date')(new Date(), 'yyyy-MM-dd')} 00:00:00`
                if ($scope.isRed) {
                    $scope.invoice.$isRed = '1'
                }
                $scope.changerUkeyId()
            }
            $scope.invoice.$isTax = '1'
            $scope.specList = []
            // $scope.invoice.blueInvoiceCode = ''
            // $scope.invoice.blueInvoiceNumber = ''
            // 获取规格列表
            if (!$scope.isDetail) {
                httpRequest.get_getSysOrgRollticketSpecList().then((res) => {
                    // if (res.data.success) {
                    $scope.specList = res.data
                    if ($scope.specList.length) {
                        if (!$scope.waitId) $scope.rollticketCode = $scope.specList[0].code
                        // 初始化最大行数
                        $scope.invoice.limitNumber = $scope.specList.filter((item) => item.code == $scope.rollticketCode)[0].maxnumber
                    }
                    // }
                })
            }
            // details增加空对象用于绑定项目组件
            // $scope.invoice.details.forEach((item) => {
            //     item.goodsObject = { shortAndMatName: item.shortAndMatName }
            // })
            // 初始化buyer对象
            $scope.buyer = $scope.invoice.customer
            $scope.buyer.customerName = $scope.buyer.custName
            $scope.buyer.creditCode = $scope.buyer.custCreditCode
            $scope.version = $scope.invoice.details[0].revenueVersion
            // 初始化发票类型为卷票
            $scope.invoice.invType = '41'
        }

        $scope.createTime = new Date()
        if (!$scope.isDetail) {
            $scope.$watch('invoice.customer.custCreditCode', () => {
                $scope.invoice.customer.custCreditCode = $scope.invoice.customer.custCreditCode && $scope.invoice.customer.custCreditCode.toUpperCase()
            })
            $scope.$watch('invoice.remark', (newV, oldVal) => {
                if ($scope.specList && $scope.specList.length) {
                    const specObj = $scope.specList.filter((item) => item.code == $scope.rollticketCode)[0]
                    const specification = specObj && specObj.specification
                    if (specification == '76mm*177mm') {
                        if (newV && newV.length > 170) $scope.invoice.remark = oldVal
                    } else if (newV && newV.length > 136) $scope.invoice.remark = oldVal
                }
            })
        }
        $scope.selectedRows = []
        // 选择规格
        $scope.changeSpec = function changeSpec() {

            const spec = $scope.specList.filter((item) => item.code == $scope.rollticketCode)[0]
            spec && ($scope.invoice.limitNumber = spec.maxnumber)
            if ($scope.invoice.details.length > $scope.invoice.limitNumber) {
                logger.logError(`增值税普通发票（卷票）最大允许${$scope.invoice.limitNumber}行商品明细`)
            }
        }
        $scope.taxRateChange = function taxRateChange(goods) {
            goods.$taxRate = goods.taxRateObj.taxRate
            goods.isPrivilege = goods.taxRateObj.isPrivilege
            goods.privilegeType = goods.taxRateObj.privilegeType
            for (let i = 0, l = $scope.dictionary.zero_tax.length; i < l; i++) {
                if ($scope.dictionary.zero_tax[i].enumName === goods.privilegeType && goods.$taxRate === 0) {
                    goods.zeroTax = $scope.dictionary.zero_tax[i].enumCode
                }
            }
        }

        // 切换开票点
        $scope.changerUkeyId = function changerUkeyId() {
            getStockByUkey()
            const selectedUeky = getSelectedUkey()
            $scope.invoice.ukey = new Ukey().fromUkey(selectedUeky)
            $scope.invoice.ukey.ukeyList.forEach((item) => {
                if (item.ukeyId == $scope.invoice.ukey.ukeyId) {
                    $scope.invoice.sale.saleBank = item.bank + ' ' + item.bankAccount // 销方开户银行 ,
                    $scope.invoice.sale.saleBankAccount = '' // 销方开户银行账号
                }
            })
            getQuotasByUkey()
        }

        // 选择项目回调
        $scope.changeGoods = function changeGoods(item, index) {
            console.log(item)
            $timeout(() => {
                // 税收分类编码版本好号
                $scope.version = item.codeVersions
                // 项目明细转换
                // const serialNo = item.serialNo
                // $scope.invoice.details[index].goodsObject.taxInclud = '1'
                $scope.invoice.details[index] = $scope.invoice.details[index].fromGoods(item)
                // if ($scope.invoice.details[index].isTax == 0) $scope.invoice.details[index].$taxPrice = ($scope.invoice.details[index].price * (1 + $scope.invoice.details[index].taxRate)).toFixed(2)
                // $scope.invoice.details[index].isTax == '1'
                $scope.invoice.details[index].serialNo = +index + 1
                if ($scope.isRed || $scope.invoice.isRed == 1) $scope.invoice.details[index].isRed = '1'
                // $scope.invoice.details[index].goodsObject = { shortAndMatName: $scope.invoice.details[index].shortAndMatName }
                getGoodsInfoTax($scope.invoice.details[index], '41').then((taxRateArr) => {
                    $scope.invoice.details[index].taxRateArr = taxRateArr
                })
            })
        }
        // 选择购方回调
        $scope.changeBuyer = function changeBuyer($item) {
            $timeout(() => {
                // 购方转换
                $scope.invoice.customer = $scope.invoice.customer.fromCustomer($item)
                $scope.invoice.customer.custCreditCode = $scope.invoice.customer.custCreditCode
                $scope.invoice.customer.custName = $scope.invoice.customer.custName
            })
        }
        // 是否含有折扣行
        $scope.hasDisBalelectedArr = billChangeService.hasDisBalelectedArr
        // 复制
        $scope.copyInvoice = function copyInvoice(item) {
            $scope.selectedRows = []
            $scope.invoice.sale = new Sale(item)
            $scope.invoice.customer = new Customer().fromInvoice(item)
            $scope.invoice.remark = item.remark
            $scope.buyer = $scope.invoice.customer
            $scope.buyer.customerName = $scope.buyer.custName
            $scope.buyer.creditCode = $scope.buyer.custCreditCode
            const details = item.waitDetailList || item.invoiceDetailList || []
            $scope.invoice.details = []
            details.forEach((detail) => {
                // detail.goodsObject = { shortAndMatName: detail.shortAndMatName }
                getGoodsInfoTax(detail, '41').then((taxRateArr) => {
                    detail.taxRateArr = taxRateArr
                    $scope.invoice.details.push(new Goods().fromInvoiceDetail(detail, '41'))
                })
            })
            $scope.rollticketCode = item.extendInfo && JSON.parse(item.extendInfo).rollticketCode
            $scope.rollticketCode && $scope.changeSpec()
        }
        // 查找蓝票
        $scope.copyFromBlue = function copyFromBlue(item) {
            $scope.invoice.fromBlue(item)
            $scope.invoice.details.forEach((detail) => {
                getGoodsInfoTax(detail, '41').then((taxRateArr) => {
                    detail.taxRateArr = taxRateArr
                })
            })
            // details增加空对象用于绑定项目组件
            // $scope.invoice.details.forEach((item) => {
            //     item.goodsObject = { shortAndMatName: item.shortAndMatName }
            // })
            // 初始化buyer对象
            $scope.buyer = $scope.invoice.customer
            $scope.buyer.customerName = $scope.buyer.custName
            $scope.buyer.creditCode = $scope.buyer.custCreditCode
            $scope.rollticketCode = JSON.parse($scope.invoice.extendInfo).rollticketCode
            $scope.rollticketCode && $scope.changeSpec()
        }
        /**
         * 红票专属方法  根据备注查找蓝票
         */
        if ($scope.isRed || $scope.invoice.isRed == 1) {
            $scope.blueCheck = function blueCheck(v) {
                const {
                    invoice
                } = $scope
                if ((invoice.blueInvoiceCode === '' && invoice.blueInvoiceNumber === '') || invoice.isRed === '0') {
                    return
                }
                const invoiceCodeReg = /^[\d]{10}$|^[\d]{12}$/
                const invoiceNumReg = /^[\d]{8}$/
                if (v == 'code') {
                    if (!invoiceCodeReg.test($scope.invoice.blueInvoiceCode)) {
                        logger.logError('您输入的发票代码格式不正确')
                        $scope.invoice.blueInvoiceCode = ''
                    }
                } else if (!invoiceNumReg.test($scope.invoice.blueInvoiceNumber)) {
                    logger.logError('您输入的发票号码格式不正确')
                    $scope.invoice.blueInvoiceNumber = ''
                }
            }
            $scope.$watch('invoice.blueInvoiceNumber', (next, pre) => {
                $scope.invoice.remark = next ? `对应正数发票代码:${$scope.invoice.blueInvoiceCode}号码:${$scope.invoice.blueInvoiceNumber}` : ''
            }, true)
            $scope.$watch('invoice.blueInvoiceCode', (next, pre) => {
                $scope.invoice.remark = next ? `对应正数发票代码:${$scope.invoice.blueInvoiceCode}号码:${$scope.invoice.blueInvoiceNumber}` : ''
            }, true)
        }
        // 暂存
        $scope.scratch = function scratch() {
            // 规格转换成后台需要的数据格式
            // $scope.invoice.customer = new Customer().fromCustomer($scope.buyer)
            if (!$scope.rollticketCode) {
                logger.logError('卷票规格为空，请先选择')
                return
            }
            $scope.invoice.extendInfo = JSON.stringify({
                rollticketCode: $scope.rollticketCode,
            })
            buyerChecker.checkBuyerCreditCode($scope.invoice.toWaitDTO().custCreditCode, $scope.invoice.toWaitDTO().creditType).then(() => {
                invoiceOpenService.checkAndscratch($scope.invoice.toWaitDTO()).then((res) => {
                    $scope.invoice.remark = res.data.value.remark
                    logger.logSuccess('暂存成功')
                }, (error) => {
                    logger.logError(error)
                })
            })
        }
        // 开票
        function open(invoiceDTO) {
            utils.loading('开票中，请耐心等待')
            if (invoiceOpenService.checkIsA9(invoiceDTO.ukeyId)) {
                httpRequest.post_openInvoice({
                    waitId: invoiceDTO.waitId,
                    deleteFlag: $scope.isRedInfo,
                    reopenInvoiceId: $scope.isCancelReopenInv ? $scope.canceledInvoiceId : ''
                }).then(res => {
                    if (res.data.value.code == 0) {
                        logger.logSuccess('开票成功')
                    } else {
                        logger.logError(res.data.value.msg)
                    }
                }).finally(() => {
                    $scope.goListPage()
                    utils.loaded()
                })
            } else {
                invoiceOpenService.checkDiskAndOpen(invoiceDTO).then(() => {
                    logger.logSuccess('开票成功')
                    $scope.isCancelReopenInv && cancelRewrite(0,invoiceDTO.waitId)
                }, (error) => {
                    $scope.isCancelReopenInv && cancelRewrite(1,invoiceDTO.waitId)
                    logger.logError(error.retmsg || error)
                    $scope.isRedInfo && httpRequest.post_reddingFailedBackWrite([$scope.invoice.waitId])
                }).finally(() => {
                    utils.loaded()
                    $scope.goListPage()
                })
            }
        }
        // 开票打印
        function openAndPrint(invoiceDTO) {
            utils.loading('开票打印中，请耐心等待')
            invoiceOpenService.checkDiskAndOpenPrint(invoiceDTO).then(() => {
                $scope.isCancelReopenInv && cancelRewrite(0,invoiceDTO.waitId)
                logger.logSuccess('开票打印成功')
            }, (error) => {
                $scope.isCancelReopenInv && cancelRewrite(1,invoiceDTO.waitId)
                logger.logError(error.retmsg || error)
                $scope.isRedInfo && httpRequest.post_reddingFailedBackWrite([$scope.invoice.waitId])
            }).finally(() => {
                utils.loaded()
                $scope.goListPage()
            })
        }

        function check(invoice, callback) {
            const userInfo = JSON.parse(localStorage.getItem('user_info'))
            if (userInfo.org.invoiceFlag !== 1) {
                logger.logError('您所在机构禁止开票，请联系管理员启用')
                return
            }
            if (userInfo.sale.taxplayerType === '3' ||
                userInfo.sale.taxplayerType === '4' ||
                userInfo.sale.taxplayerType === '9') {
                logger.logError('您所在企业纳税人类型不具备开票资格')
                return
            }
            if (!operationService.hasPermit('open_invoice_r')) {
                return
            }
            if ($scope.invoice.description && ($scope.invoice.description.slice(0, 4) == '4003' || $scope.invoice.description.slice(0, 4) == '4005')) {
                sweetalert.confirm('操作提醒', '发票上次写库失败，请先到开票软件进行发票修复后，再点击确认。避免重复开具该发票，造成跳号错觉').then(() => {
                    if (invoice.checker && invoice.payee && invoice.checker.trim() === invoice.payee.trim()) {
                        sweetalert.confirm(
                            '操作提醒',
                            '收款人和复核人为同一个人，可能影响发票的认可度，确定开票吗？',
                        ).then(() => {
                            callback(invoice)
                        })
                    } else {
                        callback(invoice)
                    }
                })
            } else if (invoice.checker && invoice.payee && invoice.checker.trim() === invoice.payee.trim()) {
                sweetalert.confirm(
                    '操作提醒',
                    '收款人和复核人为同一个人，可能影响发票的认可度，确定开票吗？',
                ).then(() => {
                    callback(invoice)
                })
            } else {
                callback(invoice)
            }
        }
        $scope.openRedInv = function openRedInv() {
            const invoiceDTO = $scope.invoice.toWaitDTO()
            if (!$scope.rollticketCode) {
                logger.logError('卷票规格为空，请先选择')
                return
            }
            if (typeof $scope.invoice.extendInfo !== 'string') {
                invoiceDTO.extendInfo = JSON.stringify({
                    rollticketCode: $scope.rollticketCode,
                })
            }
            buyerChecker.checkBuyerCreditCode(invoiceDTO.custCreditCode, invoiceDTO.creditType).then(() => {
                const error = submitCheck(invoiceDTO)
                if (error) {
                    logger.logError(error)
                    return
                }
                if ($scope.isCancelReopenInv) { //发票重开
                    utils.loading('正在保存，请稍候')
                    invoiceDTO.originalInvoiceId = $scope.canceledInvoiceId
                    if (invoiceDTO.isRed === '1') {
                        httpRequest.post_checkOvatInvoiceList({
                            invoiceCode: invoiceDTO.blueInvoiceCode,
                            invoiceNumber: invoiceDTO.blueInvoiceNumber,
                            invoiceType: invoiceDTO.invType,
                        }).then((res) => {
                            if (res.data.value) {
                                invoiceOpenService.reopenInvoiceWait(invoiceDTO).then((res) => {
                                    utils.loaded()
                                    check(invoiceDTO, open)
                                })
                            } else {
                                utils.loaded()
                                sweetalert.confirm('操作提醒', '本地没有找到对应蓝票，是否要提交？').then(() => {
                                    invoiceOpenService.reopenInvoiceWait(invoiceDTO).then((res) => {
                                        check(invoiceDTO, open)
                                    })
                                })
                            }
                        }, (error) => {
                            utils.loaded()
                            logger.logError(error)
                        })
                    } else {
                        invoiceOpenService.reopenInvoiceWait(invoiceDTO).then((res) => {
                            utils.loaded()
                            check(invoiceDTO, open)
                        }, (error) => {
                            utils.loaded()
                        })
                    }
                } else {
                    utils.loading('正在保存，请稍候')
                    httpRequest.post_reddingInvoice(invoiceDTO).then((res) => {
                        if (res.data.success && res.data.value) {
                            const waitInvoice = res.data.value
                            httpRequest.post_lockOvatInvoice({
                                invoiceIds: [$scope.parentInvoiceId],
                                isLock: '1'
                            }).then(() => { // 锁票
                                utils.loaded()
                                if (waitInvoice.waitInvoiceStatus === '2') {
                                    check(waitInvoice, open)
                                } else {
                                    $scope.goListPage()
                                }
                            }).finally(() => {
                                httpRequest.post_lockOvatInvoice({
                                    invoiceIds: [$scope.parentInvoiceId],
                                    isLock: '0'
                                }) // 释放票
                            })
                        }
                    }, (error) => {
                        utils.loaded()
                        logger.logError(error)
                    })
                }
            })
        }
        $scope.openRedInvAndPrint = function openRedInvAndPrint() {
            const invoiceDTO = $scope.invoice.toWaitDTO()
            if (!$scope.rollticketCode) {
                logger.logError('卷票规格为空，请先选择')
                return
            }
            if (typeof $scope.invoice.extendInfo !== 'string') {
                invoiceDTO.extendInfo = JSON.stringify({
                    rollticketCode: $scope.rollticketCode,
                })
            }
            buyerChecker.checkBuyerCreditCode(invoiceDTO.custCreditCode, invoiceDTO.creditType).then(() => {
                const error = submitCheck(invoiceDTO)
                if (error) {
                    logger.logError(error)
                    return
                }
                if ($scope.isCancelReopenInv) { //发票重开
                    utils.loading('正在保存，请稍候')
                    invoiceDTO.originalInvoiceId = $scope.canceledInvoiceId
                    if (invoiceDTO.isRed === '1') {
                        httpRequest.post_checkOvatInvoiceList({
                            invoiceCode: invoiceDTO.blueInvoiceCode,
                            invoiceNumber: invoiceDTO.blueInvoiceNumber,
                            invoiceType: invoiceDTO.invType,
                        }).then((res) => {
                            if (res.data.value) {
                                invoiceOpenService.reopenInvoiceWait(invoiceDTO).then((res) => {
                                    utils.loaded()
                                    check(invoiceDTO, openAndPrint)
                                })
                            } else {
                                utils.loaded()
                                sweetalert.confirm('操作提醒', '本地没有找到对应蓝票，是否要提交？').then(() => {
                                    invoiceOpenService.reopenInvoiceWait(invoiceDTO).then((res) => {
                                        check(invoiceDTO, openAndPrint)
                                    })
                                })
                            }
                        }, (error) => {
                            utils.loaded()
                            logger.logError(error)
                        })
                    } else {
                        invoiceOpenService.reopenInvoiceWait(invoiceDTO).then((res) => {
                            utils.loaded()
                            check(invoiceDTO, openAndPrint)
                        }, (error) => {
                            utils.loaded()
                        })
                    }
                } else {
                    utils.loading('正在保存，请稍候')
                    httpRequest.post_reddingInvoice(invoiceDTO).then((res) => {
                        if (res.data.success && res.data.value) {
                            const waitInvoice = res.data.value
                            httpRequest.post_lockOvatInvoice({
                                invoiceIds: [$scope.parentInvoiceId],
                                isLock: '1'
                            }).then(() => { // 锁票
                                utils.loaded()
                                if (waitInvoice.waitInvoiceStatus === '2') {
                                    check(waitInvoice, openAndPrint)
                                } else {
                                    $scope.goListPage()
                                }
                            }).finally(() => {
                                httpRequest.post_lockOvatInvoice({
                                    invoiceIds: [$scope.parentInvoiceId],
                                    isLock: '0'
                                }) // 释放票
                            })
                        }
                    }, (error) => {
                        utils.loaded()
                        logger.logError(error)
                    })
                }
            })
        }
        $scope.goListPage = function goListPage() {
            if ($scope.isRedInfo) {
                $state.go('outputManage.billManage.openedInvoice.list')
            } else if ($scope.isCancelReopenInv) {
                $state.go('outputManage.billManage.cancelInvoice.list')
            } else {
                $state.go('outputManage.FOManage.rollTypeInvoice.list')
            }
        }

        function doSubmit(invoiceDTO) {
            invoiceOpenService.scratchAndSubmit(invoiceDTO).then((res) => {
                if (res.data.value.waitInvoiceStatus === '2') {
                    window.layer.open({
                        title: '操作提醒',
                        content: '提交成功,是否继续开票，您也可以稍后在列表页面开票',
                        btn: ['开票', '取消', '开票打印'],
                        yes(index) {
                            window.layer.close(index)
                            check(invoiceDTO, open)
                        },
                        btn2(index) {
                            window.layer.close(index)
                            $state.go('outputManage.FOManage.rollTypeInvoice.list')
                        },
                        btn3(index) {
                            window.layer.close(index)
                            check(invoiceDTO, openAndPrint)
                        },
                        cancel(index) {
                            window.layer.close(index)
                            $state.go('outputManage.FOManage.rollTypeInvoice.list')
                        },
                    })
                } else {
                    logger.logSuccess('提交成功')
                    $state.go('outputManage.FOManage.rollTypeInvoice.list')
                }
            })
        }
        // 提交
        $scope.submit = function submit() {
            // 规格转换成后台需要的数据格式
            // $scope.invoice.customer = new Customer().fromCustomer($scope.buyer)
            const invoiceDTO = $scope.invoice.toWaitDTO()
            if (!$scope.rollticketCode) {
                logger.logError('卷票规格为空，请先选择')
                return
            }
            if (typeof $scope.invoice.extendInfo !== 'string') {
                invoiceDTO.extendInfo = JSON.stringify({
                    rollticketCode: $scope.rollticketCode,
                })
            }
            buyerChecker.checkBuyerCreditCode(invoiceDTO.custCreditCode, invoiceDTO.creditType).then(() => {
                const error = submitCheck(invoiceDTO)
                if (error) {
                    logger.logError(error)
                    return
                }
                if (invoiceDTO.isRed === '1') {
                    httpRequest.post_checkOvatInvoiceList({
                        invoiceCode: invoiceDTO.blueInvoiceCode,
                        invoiceNumber: invoiceDTO.blueInvoiceNumber,
                        invoiceType: invoiceDTO.invType,
                    }).then((res) => {
                        if (res.data.value) {
                            doSubmit(invoiceDTO)
                        } else {
                            sweetalert.confirm('操作提醒', '本地没有找到对应蓝票，是否要提交？').then(() => {
                                doSubmit(invoiceDTO)
                            })
                        }
                    })
                } else {
                    doSubmit(invoiceDTO)
                }
            })
        }

        function cancelRewrite(reopenRet,waitId) {
            httpRequest.post_writeBackReopenInvoice({
                invoiceId: $scope.canceledInvoiceId,
                reopenRet,
                waitId
            }).then(() => {
                console.log("重开回写")
            })
        }
        $scope.openInvoiceList = function openInvoiceList() {
            const modalInstance = $uibModal.open({
                template: modalInvoiceTitle,
                controller: 'invoiceTitleModalCtrl',
                openedClass: 'mod-modal-haslist mod-modal mod-modal-lg modal-invoice-title-detail collection-invoice-detail',
                backdrop: 'static',
                resolve: {
                    items1() {
                        return {}
                    },
                },
            })
            modalInstance.result.then((res) => {
                if (!res) return
                updateScanlen()
                let {
                    bankAccount,
                    creditCode,
                    address,
                    bankName,
                    custName,
                    email,
                    message,
                    mobile,
                    phone,
                    taxplayerType
                } = res
                $scope.invoice.customer.custCreditCode = creditCode
                $scope.invoice.customer.custName = custName
                $scope.invoice.customer.creditType = taxplayerType
                $scope.invoice.customer.custAddress = (address || phone) ? address + ' ' + phone : ''
                $scope.invoice.customer.custBank = (bankName || bankAccount) ? bankName + ' ' + bankAccount : ''
                $scope.invoice.customer.custMobile = mobile
                $scope.invoice.customer.custEmail = email
            }, () => {})
        }

        function updateScanlen() {
            $scope.wsypageRequestDTO = {
                pageNum: 1,
                pageSize: 1,
                param: {
                    custName: '',
                    creditCode: '',
                    mobile: '',
                    startDate: '',
                    endDate: '',
                    departmentName: '',
                    useStatus: '0',
                },
            };
            httpRequest.post_getSysDepartmentQrCust($scope.wsypageRequestDTO).then(res => {
                if (res.data.success) {
                    $scope.scanTitleLen = res.data.value.total;
                }
            });
        }

    }
}
rollTypeInvoiceAddCtrl.$inject = ['$scope', 'httpRequest', '$state', '$stateParams', 'logger', 'dictService', '$filter', '$timeout', 'billChangeService', 'invoiceOpenService', 'operationService', 'sweetalert', 'buyerChecker', '$uibModal']


// WEBPACK FOOTER //
// ./src/app/outputManage/fillOpenManage/rollTypeInvoice/add.js